import { render } from "./CappPaymentsHistory.vue?vue&type=template&id=a1c9f5d4&ts=true"
import script from "./CappPaymentsHistory.vue?vue&type=script&lang=ts"
export * from "./CappPaymentsHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__